<template>
    <div>
        <div id="box">
            <h1>登陆</h1>
            推荐使用Chrome登陆。
            <input placeholder="账号"
                   ref="username"/>
            <input placeholder="密码"
                   type="password"
                   ref="password"/>
            <span v-show="message">{{message}}</span>
            <button @click="login"
                    class="button"
                    :disabled="disabled">
                登陆
            </button>
        </div>
    </div>
</template>

<script>
	import auth from "../services/AuthService";

	export default {
		name: "Login",
		data() {
			return {
				message: "",
                disabled: false
			}
		},
		methods: {
			login() {
				this.disabled = true;
				auth.login(this.$refs.username.value,
                    this.$refs.password.value).then(() => {
					this.$emit("set-login", true);
					this.$router.push("/newsroom");
				}).catch((e) => {
					if (e === "incorrect") {
						this.message = "账号或密码错误";
                    } else {
						console.log(e);
						this.message = "请求失败，参见调试输出";
                    }
				}).finally(() => {
					this.disabled = false;
                });
			}
		}
	}
</script>

<style scoped lang="scss">

    div {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    #box {
        position: relative;
        margin-left: 64px;
        padding: 16px 64px;
        width: 200px;
        border: $solid;
    }

    #box::after {
        content: " ";
        position: absolute;
        bottom: -9px;
        left: 8px;
        right: 8px;
        height: 8px;
        background-color: $p-accent;
    }

    h1 {
        font-family: serif;
    }

    input, .button {
        display: block;
        line-height: 28px;
        font-size: $font-desktop;
        margin-top: 8px;
    }

    .button {
        margin-top: 20px;
        margin-bottom: 16px;
    }

    span {
        color: $s-accent;
        margin-top: 8px;
    }

    .button {
        height: 36px;
        padding: 0 16px;
    }
</style>